"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PickerItem = void 0;
const tslib_1 = require("tslib");
const MenuItem_1 = tslib_1.__importDefault(require("@material-ui/core/MenuItem"));
const react_1 = tslib_1.__importDefault(require("react"));
exports.PickerItem = (_a) => {
    var { label, value } = _a, rest = tslib_1.__rest(_a, ["label", "value"]);
    return (react_1.default.createElement(MenuItem_1.default, Object.assign({}, rest, { value: value || rest['data-value'] }), label));
};
